import { action, observable, computed } from 'mobx';
import UnderLyingEnum from '../@enums/UnderLyingEnum';

export class Underlying {
  underlyinges = [UnderLyingEnum.U_BASED, UnderLyingEnum.COIN_BASED];

  @observable currentUnderlying = UnderLyingEnum.U_BASED;

  @action.bound
  setCurrentUnderLying(value: UnderLyingEnum): void {
    this.currentUnderlying = value;
  }

  @computed get isUBased(): boolean {
    return this.currentUnderlying === UnderLyingEnum.U_BASED;
  }
}
export default new Underlying();
